var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmationDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6870EB36-2EF0-4A77-B9D9-1586610E8D09") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Submitted-1",
    transform: "translate(-387.000000, -730.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(360.000000, 700.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-receipt",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,21 L3,3.99985364 C3,2.89447268 3.89323627,2 5.00087166,2 L18.9991283,2 C20.1044704,2 21,2.89294791 21,3.99985364 L21,21 C21,21.743382 20.2176875,22.2268777 19.5527864,21.8944272 L18.0113313,21.1236997 L16.4472136,21.8944272 C16.1656861,22.0351909 15.8343139,22.0351909 15.5527864,21.8944272 L14.0026399,21.1193539 L12.4472136,21.8944272 C12.1656861,22.0351909 11.8343139,22.0351909 11.5527864,21.8944272 L10.0031038,21.1195859 L8.44865276,21.8943179 C8.16715958,22.0351505 7.83578729,22.0352314 7.55422538,21.8945363 L6.00284223,21.1193179 L4.4472136,21.8944272 C3.7823125,22.2268777 3,21.743382 3,21 Z M18.9991283,4 L5,3.99985364 L5,19.3805542 L5.5527864,19.1055728 C5.83423709,18.9648475 6.16551031,18.964807 6.44699532,19.1054637 L8.01000977,19.8855029 L9.55256795,19.1056821 C9.83413792,18.9648111 10.1656092,18.9647706 10.4472136,19.1055728 L12,19.8839297 L13.5527864,19.1055728 C13.8343139,18.9648091 14.1656861,18.9648091 14.4472136,19.1055728 L16.0150146,19.888605 L17.5527864,19.1055728 C17.8343139,18.9648091 18.1656861,18.9648091 18.4472136,19.1055728 L19.0050049,19.3845157 L18.9991283,4 Z M12,15 C12,14.4477153 12.4437166,14 12.9998075,14 L16.0001925,14 C16.5523709,14 17,14.4438648 17,15 C17,15.5522847 16.5562834,16 16.0001925,16 L12.9998075,16 C12.4476291,16 12,15.5561352 12,15 Z M7,11 C7,10.4477153 7.44910619,10 7.99539757,10 L16.0046024,10 C16.5543453,10 17,10.4438648 17,11 C17,11.5522847 16.5508938,12 16.0046024,12 L7.99539757,12 C7.44565467,12 7,11.5561352 7,11 Z M7,7 C7,6.44771525 7.44910619,6 7.99539757,6 L16.0046024,6 C16.5543453,6 17,6.44386482 17,7 C17,7.55228475 16.5508938,8 16.0046024,8 L7.99539757,8 C7.44565467,8 7,7.55613518 7,7 Z",
    id: "path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationDetails);
export default __webpack_public_path__ + "static/media/confirmation-details.0dfb9fd3fc6a77b73aa0d22051112df1.svg";
export { ForwardRef as ReactComponent };